import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 支払い明細（確認）フラグ一覧
// 確認フラグ変更
export async function putPaymentCheckRecordFlg(dataKey: {
  [key: string]: string;
}) {
  try {
    const path = "paymentCheckFlg";
    const bodys = dataKey;
    const response = await axios.put(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 確認フラグ全変更
export async function putPaymentCheckRecordFlgs(
  dataKey: {
    [key: string]: string;
  }[]
) {
  try {
    const path = "paymentCheckFlgs";
    const bodys = { dataKey };
    const response = await axios.put(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}
